<template>
  <div class="main">
    <el-form
      :model="data"
      status-icon
      ref="form"
      label-width="80px"
      class="demo-ruleForm"
      style="width:600px"
      :rules="rules2"
    >
      <h2>修改密码</h2>
      <p class="hint" v-if="this.$route.query.isSatety">
        您的账号存在安全隐患，请及时更改密码！
      </p>
      <el-form-item label="登录账号" prop="userAccount">
        <el-input
          type="text"
          v-model="data.userAccount"
          disabled="disabled"
          placeholder="请输入用户登录账号"
        ></el-input>
      </el-form-item>
      <el-form-item label="旧密码" prop="oldPwd">
        <el-input
          type="text"
          v-model="data.oldPwd"
          placeholder="请输入旧密码"
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="pwd">
        <el-input
          type="password"
          show-password
          v-model="data.pwd"
          placeholder="请输入新密码"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPass">
        <el-input
          type="password"
          show-password
          v-model="data.checkPass"
          placeholder="请再次输入新密码"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm2('data')">提交</el-button>
        <!-- <router-link to="/login">返回登录页</router-link> -->
        <el-button type="info" style="float : right" @click="goBack"
          >返回</el-button
        >

        <!-- <span @click="goBack">返回</span> -->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { log } from "util";
export default {
  data() {
    var validateName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    var validateuserAccount = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入电话号码"));
      } else {
        callback();
      }
    };
    var validateoldPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入旧密码"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.trim() === "") {
        callback(new Error("密码中不能为空格"));
      } else if (value.indexOf(" ") !== -1) {
        callback(new Error("密码中不能包含空格"));
      } else if (
        !/^[0-9A-Za-z]{6,}$/.test(value) &&
        localStorage.getItem("securityLevel") == 0
      ) {
        callback(new Error("密码长度最短为6位，不可包含特殊符号"));
      } else if (
        !/^(?![^a-zA-Z]+$)(?!\D+$).{8,}$/.test(value) &&
        localStorage.getItem("securityLevel") == 1
      ) {
        callback(new Error("密码长度最短为8位，需要包含数字和字母"));
      } else if (
        !/^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[-!@#$%^&*+=.,]).{12,}$/.test(value) &&
        localStorage.getItem("securityLevel") == 2
      ) {
        callback(
          new Error(
            "密码长度最短为12位，需要包含数字、字母和符号(! @ # $ % ^ & * - + = . ,)"
          )
        );
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.data.pwd) {
        callback(new Error("两次输入密码不一致!"));
      } else if (value.trim() === "") {
        callback(new Error("密码中不能为空格"));
      } else if (value.indexOf(" ") !== -1) {
        callback(new Error("密码中不能包含空格"));
      } else {
        callback();
      }
    };
    return {
      checkuserAccount: true,
      checkoldPwd: true,
      timeOut: false,
      rules2: {
        name: [
          {
            validator: validateName,
            trigger: "blur"
          }
        ],
        pwd: [
          {
            validator: validatePass,
            trigger: "blur"
          }
        ],
        checkPass: [
          {
            validator: validatePass2,
            trigger: "blur"
          }
        ],
        oldPwd: [
          {
            validator: validateoldPwd,
            trigger: "blur"
          }
        ],
        userAccount: [
          {
            validator: validateuserAccount,
            trigger: "change"
          }
        ]
      },
      data: {
        name: "",
        userAccount: localStorage.userAccount,
        oldPwd: "",
        pwd: "",
        checkPass: ""
      },
      userId: null,
      stopTime: 0
    };
  },
  computed: {
    ph() {
      return this.$refs["form"].fields[0].validateMessage;
    }
  },
  methods: {
    handleIconClick() {
      if (document.getElementById("password").type === "password") {
        document.getElementById("password").type = "text";
      } else {
        document.getElementById("password").type = "password";
      }
    },
    submitForm() {
      this.dialogFormVisible = true;
    },
    submitForm2(formName) {
      this.$refs.form.validate(valid => {
        if (valid) {
          let params = new URLSearchParams();
          //params.append("userAccount", this.data.userAccount);
          params.append("oldPwd", this.data.oldPwd);
          params.append("pwd", this.data.pwd);
          this.$axiospost("manager/company/resetPwdByUserAccount", params).then(
            res => {
              if (res.data.status === 10000) {
                this.$message("密码修改成功");
                this.$router.go(-1);
              }
            }
          );
        }
      });
    },
    goBack() {
      this.$router.push({
        path: "/home"
      });
    }
  },
  mounted() {},
  created() {},
  destroyed() {}
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background: black !important;
  color: white;
  h2 {
    font-size: 24px;
    text-align: center;
    padding-bottom: 20px;
  }
  .hint {
    padding-bottom: 20px;
    color: red;
    text-align: center;
  }

  > .el-form {
    padding: 20px 50px;
    // width: 30%;
    background-color: #181c2e;
    border-radius: 5px;
    margin: 0 auto;
    > .el-form-item {
      text-align: left;
    }
    > .el-form-item__label {
      color: white;
    }
    .el-input {
      width: 100%;
    }

    span {
      color: white;
      float: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/password/changePsw/index.vue